import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const ClaimsLanding = lazyLoad(
    () => import('./index'),
    module => module.ClaimsLanding,
    { fallback: <LoadingSpinner /> },
);
